module.exports = __webpack_public_path__ + "img/conected_members.476a825c.png";